var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-tooltip',{staticClass:"w-3 h-3 min-w-3 rounded-full",class:_vm.published ? 'bg-success' : 'border-2 border-solid border-gray-dark',attrs:{"position":_vm.tooltipPosition,"title":_vm.tooltipTitle,"text":_vm.tooltipText}})}
var staticRenderFns = []

export { render, staticRenderFns }